export default __webpack_public_path__ + "static/media/laptop.22d5b858.svg";